import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCashedChecksTotalsReport extends Layout {
    sourceFuelWireTotals: DataSource;
    textboxCardProvider: Textbox;
    textboxDate: Textbox;
}